import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Card,
  CardMedia,
} from "@mui/material";
import Detail from "../../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseProduct4 } from "../UseProduct4";
import ProductGroupList from "./ProductGroupList";
import AddProductG from "./AddProductG";
import { useNavigate, useLocation } from "react-router-dom";
import useBreakpoints from "../../../../hooks/useBreakpoints";
import { FileUploader } from "react-drag-drop-files";

export default function EditGroupProduct(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { getProductByGroupID, validateGroup, UpdateProductOfferGroup } =
    UseProduct4();
  const [productsList, setProductsList] = useState([]);
  const navigate = useNavigate();
  const { isSmall } = useBreakpoints();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];

  var lastRowIndex = Math.max.apply(
    Math,
    location.state?.groupsLength.map(function (o) {
      return o.rowIndex + 1;
    })
  );

  const [imgState, setImgState] = useState({
    file: undefined,
    url: "",
    file2: undefined,
    url2: "",
  });

  const [state, setState] = useState({
    id: undefined,
    // aid: location.state.OfferID,
    rowIndex: lastRowIndex != -Infinity ? lastRowIndex : 1,
    // groupID: location.state.thisOfferId,
    title: undefined,
    productCount: undefined,
    isRotatory: false,
    bannerURL: undefined,
    moreTitle: undefined,
    moreURL: undefined,
  });

  useEffect(() => {
    if (location.state.model) {
      setState({
        id: location.state.model.id,
        aid: location.state.OfferID,
        rowIndex: location.state.model.rowIndex,
        groupID: location.state.thisOfferId,
        title: location.state.model.title,
        productCount: location.state.model.productCount,
        isRotatory: location.state.model.isRotatory,
        bannerURL: location.state.model.bannerURL,
        moreTitle: location.state.model.moreTitle,
        moreURL: location.state.model.moreURL,
      });
      setImgState({
        file: undefined,
        url: location.state.model.banner ? location.state.model.banner : "",
        file2: undefined,
        url2: location.state.model.banner2 ? location.state.model.banner2 : "",
      });
    }
  }, [location.state.model]);

  useEffect(() => {
    if (location.state.allGroups) {
      getProductByGroupID(
        location.state.OfferID,
        location.state.model.id,
        (callback) => {
          setProductsList(callback);
        }
      );
    }
  }, [location.state.allGroups]);

  const handleChangeImage = (file) => {
    setImgState({
      ...imgState,
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage2 = (file) => {
    setImgState({
      ...imgState,
      file2: file[0],
      url2: URL.createObjectURL(file[0]),
    });
  };

  const [errorState, setErrorState] = useState({
    title: false,
    productCount: false,
  });

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/ProductsOfferManage",
        title: "مدیریت محتوا",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: location.state.parentUrl && location.state.parentUrl,
          },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/ProductsOfferManage",
            OfferID: location.state.OfferID && location.state.OfferID,
            componentFaTitle:
              location.state.componentFaTitle &&
              location.state.componentFaTitle,
          },
          {
            name: "ویرایش گروه",
            url: "/ProductsOfferManage/EditGroup",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          // sx={{ border: "1px solid #E1E1E1", p: 2, borderRadius: 1 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={2}
        >
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان گروه"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 6" : "span 2"}>
            <TextField
              value={state.productCount ? state.productCount : ""}
              error={errorState.productCount}
              label="تعداد نمایش محصول"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, productCount: evt.target.value });
              }}
              fullWidth
              sx={{
                input: {
                  textAlign: "center",
                },
              }}
              type="number"
              InputProps={{
                autoComplete: "off",
                inputProps: {
                  min: 1,
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <TextField
              fullWidth
              value={state.moreTitle ? state.moreTitle : ""}
              label="عنوان لینک"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, moreTitle: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              value={state.moreURL ? state.moreURL : ""}
              label="آدرس لینک"
              size="small"
              sx={{
                textarea: {
                  direction: "rtl",
                },
              }}
              multiline
              rows={2}
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, moreURL: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{
              display: "flex",
              flexDirection: isSmall ? "column" : "row",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: 4,
            }}
          >
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "300px", height: "auto" }}>
                  <Card
                    sx={{
                      bgcolor: imgState.url && "#d7d7d7",
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.url ? imgState.url : "/static/img/nobanner.jpg"
                      }
                    />
                  </Card>
                </Box>
              }
            />
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage2(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "300px", height: "auto" }}>
                  <Card
                    sx={{
                      bgcolor: imgState.url2 && "#d7d7d7",
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.url2
                          ? imgState.url2
                          : "/static/img/nobanner.jpg"
                      }
                    />
                  </Card>
                </Box>
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              value={state.bannerURL ? state.bannerURL : ""}
              label="آدرس بنر"
              size="small"
              sx={{
                textarea: {
                  direction: "rtl",
                },
              }}
              multiline
              rows={2}
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, bannerURL: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <FormControlLabel
              checked={state.isRotatory}
              onChange={(evt) => {
                setState({ ...state, isRotatory: evt.target.checked });
              }}
              control={<Checkbox />}
              label="محصولات به صورت چرخشی نمایش داده شوند"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              onClick={() => {
                if (validateGroup(state, setErrorState) == 200) {
                  setProgress(true);
                  UpdateProductOfferGroup(
                    state,
                    imgState.file,
                    imgState.file2,
                    (callback) => {
                      navigate("/ProductsOfferManage", {
                        state: { ...location.state, isBack: true },
                        replace: true,
                      });
                    }
                  );
                }
              }}
              color="secondary"
              sx={{ mr: 1, width: "80px" }}
              variant="contained"
            >
              ثبت
            </Button>
          </Box>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            محصولات
          </Typography>
          <ProductGroupList
            rows={productsList && productsList}
            offers={location.state.model && location.state.model}
            allGroups={location.state.allGroups && location.state.allGroups}
            groupId={location.state.model.id}
            OfferID={location.state.OfferID}
            callback={(OfferID, groupId) => {
              getProductByGroupID(OfferID, groupId, (callback) => {
                setProductsList(callback);
              });
            }}
          />
        </Box>
        <Box>
          <AddProductG
            allGroups={location.state.allGroups}
            groupId={location.state.model.id}
            OfferID={location.state.OfferID}
            callback={(OfferID, groupId) => {
              getProductByGroupID(OfferID, groupId, (callback) => {
                setProductsList(callback);
              });
            }}
            offers={location.state.model && location.state.model}
          />
        </Box>
      </Box>
    </Detail>
  );
}
